import { useGetOne } from 'react-admin';

const useBillingGroup = (id: number) => useGetOne('BillingGroup', { id });

export default useBillingGroup;
